/* Clevenne cart drawer -- zie snippets/clevenne-cart-drawer.liquid
   Alleen de twee stukken die Dawn niet zelf afhandelt: de reserveringsteller en de
   best-sellers-carrousel met zijn Add-knop. Alle listeners hangen gedelegeerd aan
   <cart-drawer>, want Dawn vervangt bij elke cart-wijziging de inhoud daarvan.
   De carrousel-stand staat in een data-attribuut op de track en reset daardoor
   vanzelf zodra die track opnieuw gerenderd wordt. */
(() => {
  const drawer = document.querySelector('cart-drawer.clevenne-cart');
  if (!drawer) return;

  /* ---------- reserveringsteller ---------- */

  const RESERVATION_KEY = 'clevenne-cart-reservation-end';
  const RESERVATION_MS = 10 * 60 * 1000;

  const readReservationEnd = () => {
    try {
      return Number(sessionStorage.getItem(RESERVATION_KEY)) || 0;
    } catch (error) {
      return 0;
    }
  };
  const writeReservationEnd = (value) => {
    try {
      sessionStorage.setItem(RESERVATION_KEY, String(value));
    } catch (error) {
      /* private mode: de teller loopt dan alleen binnen deze pagina */
    }
  };

  let reservationEnd = readReservationEnd();

  const refreshTimer = () => {
    const labels = drawer.querySelectorAll('[data-clevenne-reservation]');
    if (!labels.length) return;
    if (!drawer.classList.contains('active')) return;
    if (!reservationEnd || reservationEnd < Date.now()) {
      reservationEnd = Date.now() + RESERVATION_MS;
      writeReservationEnd(reservationEnd);
    }
    const seconds = Math.max(0, Math.ceil((reservationEnd - Date.now()) / 1000));
    const minutes = String(Math.floor(seconds / 60)).padStart(2, '0');
    const label = `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
    labels.forEach((element) => {
      element.textContent = label;
    });
  };

  new MutationObserver(refreshTimer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  window.setInterval(refreshTimer, 1000);

  /* ---------- best-sellers-carrousel ---------- */

  const moveCarousel = (direction) => {
    const track = drawer.querySelector('.clev-up__track');
    if (!track) return;
    const count = track.querySelectorAll('.clev-up__card').length;
    if (count < 2) return;
    const current = Number(track.dataset.index) || 0;
    const next = (current + direction + count) % count;
    track.dataset.index = String(next);
    track.style.transform = `translateX(-${next * 100}%)`;
  };

  /* ---------- toevoegen vanuit de carrousel ---------- */

  const addUpsell = async (button) => {
    const card = button.closest('.clev-up__card');
    const variant = card?.querySelector('[data-clevenne-variant]');
    const errorElement = card?.querySelector('.clev-up__error');
    if (!variant?.value) return;

    button.disabled = true;
    if (errorElement) errorElement.hidden = true;

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variant.value), quantity: 1 }],
          sections: drawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Could not add this product');
      }
      drawer.renderContents(result);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'clevenne-cart-drawer', cartData: result });
      }
      refreshTimer();
    } catch (cause) {
      if (errorElement) {
        errorElement.textContent = cause.message || 'Could not add this product';
        errorElement.hidden = false;
      }
    } finally {
      if (button.isConnected) button.disabled = false;
    }
  };

  drawer.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-cart-arrow]');
    if (arrow) {
      moveCarousel(arrow.dataset.cartArrow === 'next' ? 1 : -1);
      return;
    }
    const addButton = event.target.closest('[data-clevenne-upsell-add]');
    if (addButton) addUpsell(addButton);
  });
})();
